// hooks/use-search.js — SEARCH ENGINE
// ============================================================================
// Owns: runSearch, search state
// ============================================================================

import { useState } from 'react';

export function useSearch({
  session, supabase,
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  async function runSearch(q) {
    if (!q.trim()) { setSearchResults([]); return; }
    setSearchLoading(true);
    try {
      const { data } = await supabase
        .from('messages')
        .select('session_id, role, content')
        .eq('user_id', session.user.id)
        .ilike('content', `%${q}%`)
        .order('created_at', { ascending: false })
        .limit(30);
      const seen = new Set();
      const grouped = (data || []).filter(m => {
        if (seen.has(m.session_id)) return false;
        seen.add(m.session_id);
        return true;
      });
      setSearchResults(grouped);
    } catch(e) { setSearchResults([]); }
    setSearchLoading(false);
  }

  return {
    runSearch,
    searchQuery, setSearchQuery,
    searchResults, setSearchResults,
    searchLoading, setSearchLoading,
  };
}
